import React from 'react';

// Lucide-react ikonlarının simülasyonu.
const Compass = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-compass"><path d="M8 16l-4 4L2 14l6-6 6-6-6-6L2 14"/><path d="M22 6L14 14l-6 6-4-4"/></svg>;
const BookOpen = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-book-open"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>;
const Globe = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-globe"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>;
const MessageCircle = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-message-circle"><path d="M7.9 20A9.9 9.9 0 0 0 12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12a9.9 9.9 0 0 0 6.6 9.4L7 22l-1-1"/></svg>;
const Gamepad = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-gamepad"><path d="M6 14.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/><path d="M14 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/><path d="M15 15.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/><path d="M17 13.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/><path d="M8.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/><path d="M16.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/><path d="M12 2a10 10 0 0 0-8.5 5.5l-2.4 2.6a1 1 0 0 0 0 1.8l2.4 2.6A10 10 0 1 0 12 2z"/></svg>;
const QrCode = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-qr-code"><rect width="8" height="8" x="2" y="2" rx="1"/><rect width="8" height="8" x="14" y="2" rx="1"/><rect width="8" height="8" x="2" y="14" rx="1"/><path d="M16 16h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2zm4 0h2v2h-2zm0-2h2v2h-2z"/></svg>;
const SunMoon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-sun-moon"><path d="M12 8a4 4 0 0 1 4 4c0 4.4-3.6 8-8 8A4 4 0 0 1 12 8z"/><path d="M12 2a10 10 0 1 0 0 20V2z"/><path d="M12 2v20a10 10 0 0 0-10-10A10 10 0 0 0 12 2z"/></svg>;

// Özellik kartı için bileşen, daha dinamik ve renkli bir tasarım
const FeatureCard = ({ icon: Icon, title, description, color, delay }) => (
  <div
    style={{ animationDelay: `${delay}ms` }}
    className={`
      flex flex-col items-center p-8 bg-gray-800 border border-gray-700 rounded-3xl shadow-xl
      transform transition-all duration-500 ease-in-out
      hover:scale-105 hover:shadow-2xl hover:border-transparent
      relative overflow-hidden group animate-fade-in hover:pt-px
      ${color}
    `}
  >
    <div className="absolute inset-0 bg-opacity-20 backdrop-filter backdrop-blur-lg"></div>
    <div className="relative z-10 flex flex-col items-center">
      <div className="p-5 rounded-full mb-4 bg-gradient-to-br from-white/20 to-white/10 group-hover:from-white/30 group-hover:to-white/20 transition-all duration-300">
        <Icon className="w-10 h-10 text-white" />
      </div>
      <h3 className="text-2xl font-black text-white text-center mb-2">{title}</h3>
      <p className="text-gray-300 text-base text-center font-light">{description}</p>
    </div>
  </div>
);

const App = () => {
  const features = [
    {
      icon: BookOpen,
      title: "Detaylı Hikayeler",
      description: "Mekanların sadece genel tarihini değil, içindeki özel sanat eserlerinin, mimari detayların ve yazıtların hikayelerini sesli ve yazılı olarak sunarız.",
      color: "from-blue-500 to-indigo-600",
    },
    {
      icon: MessageCircle,
      title: "Akıllı Sohbet Asistanı",
      description: "Mekanlar hakkında merak ettiklerinizi sorabileceğiniz, sohbet edebileceğiniz ve öneriler alabileceğiniz yapay zeka destekli sohbet robotu.",
      color: "from-pink-500 to-purple-600",
    },
    {
      icon: Globe,
      title: "Engelsiz Yaşam",
      description: "Görme ve İşitme engelli vatandaşlarımıza erişilebilir anlatım ve kullanım.",
      color: "from-green-500 to-teal-600",
    },
    {
      icon: Globe,
      title: "Çoklu Dil Desteği",
      description: "Türkçe ve İngilizce dil seçenekleriyle dünya genelindeki kullanıcılara hitap eder, tarihi bilgileri kolayca ulaşılabilir hale getiririz.",
      color: "from-green-500 to-teal-600",
    },
    {
      icon: QrCode,
      title: "Mekânname QR Kodları",
      description: "Mekanlara yerleştirilecek özel QR kodlarıyla, anında detaylı bilgi ve sesli anlatım sunarak etkileşimli bir deneyim sağlarız.",
      color: "from-yellow-500 to-orange-600",
    },
  ];

  return (
    <div className="bg-gradient-to-br from-gray-950 to-gray-800 min-h-screen py-16 px-4">
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.6s ease-out forwards;
        }
      `}</style>

      <div className="container mx-auto max-w-7xl">
        {/* Başlık ve açıklama bölümü */}
        <div className="relative text-center mb-20">
          <h1 className="text-4xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 drop-shadow-xl animate-fade-in">
            Mekânname'nin Geleceği
          </h1>
          <p className="text-gray-400 text-xl md:text-xl mt-4 max-w-4xl mx-auto animate-fade-in" style={{ animationDelay: '200ms' }}>
            Uygulamayı bir sonraki seviyeye taşıyacak, kültürel keşif deneyimini zenginleştirecek yeni özellikler.
          </p>
        </div>

        {/* Özelliklerin listelendiği kart bölümü */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              color={`bg-gradient-to-br ${feature.color}`}
              delay={(index + 1) * 100}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default App;
